import styled from "styled-components";

const Colors = {
    background: "rgb(254 249 255)"
}

export const ScreenBackground = styled.div`
    width: 100%;
    height: 100%;
    background: ${Colors?.background};
    display: flex;
    justify-content: center;
    gap: 60px;
    padding: 10px;
`

export const StyledText = styled.div`
    font-family: Outfit;
    font-size: ${props => props?.heading ? '35px' : '18px'};
    font-weight: ${props => props?.heading ? '800' : '300'};
    line-height: ${props => props?.heading ? '44px' : '22.68px'};
    text-align: left;
    color: ${props => props?.heading ? '#3D0078' : '#6B2AAB'};

    @media (max-height: 650px) {
        ${props => !props?.heading && `display: none`};
    }

    @media (max-width: 520px) {
        font-size: ${props => props?.heading ? '22px' : '14px'};
        font-weight: ${props => props?.heading ? '800' : '300'};
        line-height: ${props => props?.heading ? '27px' : '17.68px'};
        text-align: left;
    }
`

export const PhonePart = styled.div`
    height: 100%;
    width: 273px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 42px;
    align-items: center;
    @media (max-width: 900px) {
        display: none;
    }
`

export const DetailPart = styled.div`
    height: 100%;
    width: 435px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
`

export const RedirectionItemsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 10px;
    @media (max-width: 520px){
        justify-content: center;
    }
`

export const StoresContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
    font-family: Outfit;
    font-size: 14px;
    font-weight: 300;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: center;
    color: #6B2AAB;
    width: 180px;
`

export const QRCodeContainer = styled.div`
    height: 177.74px;
    width: 177.74px;
    border-radius: 8px;
    background: #FFF;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 520px) {
        display: none;
    }
`

export const ScanQRText = styled.div`
    @media (max-width: 520px) {
        display: none;
    }
`

export const PhoneElement = styled.div`
    width: 273px;
    height: 500px;
    position: relative;
`

export const PhoneSkeleton = styled.img`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
`

export const PhoneScreen = styled.img`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
`

export const CloseButton = styled.img`
    cursor: pointer;
    position: absolute;
    top: 30px;
    right: 30px;
    height: 20px;
    width: 20px;
`